import React from "react";
import { Redirect } from "react-router-dom";

import Dashboard from "../pages/Dashboard.js";
import Login from "./../pages/login/LoginPage";
import Terceros from "./../pages/terceros/Terceros";
import DatosCliente from "./../pages/terceros/DatosTercero";
import RegistrarFactura from "./../pages/ventas/RegistrarFactura";
import Talonario from "./../pages/parametros/Talonario";
import DatosTalonario from "./../pages/parametros/DatosTalonario";
import ComprobantesEmitidos from "./../pages/ventas/ComprobantesEmitidos";
import RegistroCobros from "../pages/ventas/RegistroCobros.js";
import Comprobante from "./../pages/ventas/Comprobante";
import Cobro from "../pages/ventas/Cobro";
import Usuarios from "../pages/usuarios/Usuarios";
import DatosUsuario from "../pages/usuarios/DatosUsuario";
import Remasur from "../pages/hidden/Remasur.js";

const routes = [
    {
        path: "/",
        exact: true,
        component: () => <Redirect to="/dashboard" />,
    },
    {
        path: "/remasur",
        exact: true,
        component: () => <Remasur />,
    },
    {
        path: "/dashboard",
        exact: true,
        title: "Dashboard",
        component: () => <Dashboard />,
    },
    {
        path: "/login",
        title: "Login",
        component: () => <Login />,
    },
    {
        exact: true,
        path: "/terceros",
        title: "Terceros",
        component: () => <Terceros />,
    },
    {
        exact: true,
        path: ["/tercero/:id", "/tercero"],
        title: "Datos de cliente",
        component: () => <DatosCliente />,
    },
    {
        exact: true,
        path: "/venta/registrar_factura",
        title: "Registrar Factura",
        component: () => <RegistrarFactura />,
    },
    {
        exact: true,
        path: "/venta/facturas_emitidas",
        title: "Comprobantes Emitidos",
        component: () => <ComprobantesEmitidos />,
    },
    {
        exact: true,
        path: "/venta/comprobante/:comprobante_id",
        title: "Comprobante",
        component: () => <Comprobante />,
    },
    {
        exact: true,
        path: "/venta/registro_cobros",
        title: "Registro de cobros",
        component: () => <RegistroCobros />,
    },
    {
        exact: true,
        path: "/parametros/talonario",
        title: "Talonarios",
        needAdmin: true,
        component: () => <Talonario />,
    },
    {
        exact: true,
        path: "/parametros/talonario/datos_talonario/:talonario_id",
        title: "Datos de talonario",
        component: () => <DatosTalonario />,
    },
    {
        exact: true,
        path: "/venta/registro_cobros/:cobro_id",
        title: "Cobro",
        component: () => <Cobro />,
    },
    {
        exact: true,
        path: "/usuarios",
        title: "Usuarios",
        needAdmin: true,
        component: () => <Usuarios />,
    },
    {
        // exact: true,
        path: ["/usuario/:id", "/usuario"],
        title: "Datos de usuario",
        component: () => <DatosUsuario />,
    },
];

export default routes;
